import { clear_token } from "@/router";
import Swal from 'sweetalert2';
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"

export default {

  components: {
    HomeNavBar,
  },
  methods: {
    logout_user() {
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log out!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          clear_token();
          window.location = `/sign_in_finale`;
        }
      });
    },

    scroll_cards(direction) {
      const container = this.$refs.cardsRow; // use ref here
      if (!container) return;

      const scrollAmount =550;
      const offset = direction === "left" ? -scrollAmount : scrollAmount;

      container.scrollBy({ left: offset, behavior: "smooth" });
    }
  }
};